export default __webpack_public_path__ + "static/media/mima.cdb2f303.png";